import React from 'react';
import {baseFilename} from '../../utils/common';
import IconButton from '@material-ui/core/IconButton';
import {Clear as ClearIcon} from '@material-ui/icons';


export default function SupplementalFileList(props) {
    return (
        <div>
            <h4>Uploaded Resources</h4>
            <ul>
                {props.supplementFiles.map((supplement, index) => (
                    <li key={`supplemental-file-item-${index}`} className="supplemental-file-item">
                        <span>{baseFilename(supplement.url)}</span>
                        <IconButton
                            onClick={props.removeFileSupplement(this, index)} size="small">
                            <ClearIcon/>
                        </IconButton>
                    </li>
                ))}
            </ul>
        </div>
    );
};
